<template>
  <thead class="anz-hidden-mo">
    <tr>
      <th class="anz-fs-xxxs anz-align-left">
        {{ $translate('profile.labels.user') }}
      </th>
      <th class="anz-align-center anz-fs-xxxs">
        {{ $translate('profile.labels.lastActivity') }}
      </th>
      <th class="anz-align-center anz-fs-xxxs">
        {{ $translate('profile.labels.postCount') }}
      </th>
      <th class="anz-align-center anz-fs-xxxs">
        {{ $translate('profile.labels.blogger') }}
      </th>
      <th class="anz-align-center anz-fs-xxxs">
        {{ $translate('profile.labels.action') }}
      </th>
    </tr>
  </thead>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UserHeader',
  data() {
    return {
      isActive: false,
    }
  },
  props: {
    user: {
      type: Object,
      default: {},
    },
  },
})
</script>
